// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/ic_exclamation.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Root styles */
* {
  box-sizing: border-box;
}

:root {
  --bs-body-font-size: 16px !important;
  --bs-body-color: #121619 !important;
  color: #121619 !important;
}

/* React: runtime error 검은색 팝업이 뜨는 문제 수정 */
iframe#webpack-dev-server-client-overlay {
  display: none;
}

/********************************** 
 * Font 
 **********************************/
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 100;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf) format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 300;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf) format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf) format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf) format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf) format("opentype");
}
@font-face {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 900;
  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff2) format("woff2"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff) format("woff"), url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.otf) format("opentype");
}
@font-face {
  font-family: "SUIT";
  font-weight: 100;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 200;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 300;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 400;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 500;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 600;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 700;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 800;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "SUIT";
  font-weight: 900;
  font-style: normal;
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.eot");
  src: url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.eot?#iefix") format("embedded-opentype"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.woff2") format("woff2"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.woff") format("woff"), url("https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.ttf") format("truetype");
  font-display: swap;
}
.fs-5-5 {
  font-size: 1.1rem !important;
}

.fs-6-5 {
  font-size: 0.9rem !important;
}

.fs-7 {
  font-size: 0.8rem !important;
}

.text-size-16 {
  font-size: 16px;
}

.text-size-18 {
  font-size: 18px;
}

.text-size-20 {
  font-size: 20px;
}

.text-size-24 {
  font-size: 24px;
}

.fw-500 {
  font-weight: 500;
}

.fw-300 {
  font-weight: 300;
}

.fw-100 {
  font-weight: 100;
}

.font-suit {
  font-family: "SUIT", "Noto Sans KR", sans-serif;
}

/* Text */
.text-light-black {
  color: #373b3e;
}

.text-yellow {
  color: #ffe800;
}

.text-gray-1 {
  color: #697077;
}

.text-gray-2 {
  color: #878d96;
}

.text-red {
  color: red;
}

.text-depp-red {
  color: #cb2128;
}

.text-orange {
  color: #d98c00;
}

.text-light-orange {
  color: #f2a61c;
}

.text-blue {
  color: #0d6efd;
}

.text-green {
  color: #4aba64;
}

.text-starbucks-green {
  color: #034f30;
}

.text-white {
  color: white;
}

.text-primary {
  color: #6b63ff;
}

.text-yellow-new {
  color: #ffe515;
}

.text-orange {
  color: #d98c00;
}

.text-gray {
  color: #999999;
}

.text-purple {
  color: #6c63ff;
}

.text-vat {
  color: #495afc;
}

.text-vat-theme {
  color: #495afc;
}

.text-light-orange {
  color: #f2a61c;
}

.text-light-gray {
  color: #67686a;
}

.text-other-gray {
  color: #878d96;
}

.text-lighter-gray {
  color: #93969a;
}

.text-more-lighter-gray {
  color: #c4c4c4;
}

.text-dark-gray {
  color: #697077;
}

.text-deep-dark-gray {
  color: #3b3b3b;
}

.text-semi-black {
  color: #121619;
}

.text-red {
  color: #f80707;
}

.text-deep-red {
  color: #cb2128;
}

.text-pre-line {
  white-space: pre-line;
}

.text-underline {
  text-decoration: underline;
}

.text-thick-underline {
  position: relative;
  isolation: isolate;
}
.text-thick-underline::after {
  position: absolute;
  width: 90%;
  height: 10px;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
  background-color: #ffe800;
  z-index: -1;
  content: "";
}

.text-thick-underline-full-width {
  position: relative;
  isolation: isolate;
}
.text-thick-underline-full-width::after {
  position: absolute;
  width: 100%;
  height: 10px;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
  background-color: #ffe800;
  z-index: -1;
  content: "";
}

.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.text-overflow-keep {
  overflow: visible;
  white-space: nowrap;
  word-break: keep-all;
}

.line-height-100 {
  line-height: 100%;
}

.line-height-120 {
  line-height: 120%;
}

.line-height-140 {
  line-height: 140%;
}

.line-height-160 {
  line-height: 160%;
}

.line-height-180 {
  line-height: 180%;
}

.line-height-200 {
  line-height: 200%;
}

.text-align-left {
  text-align: left;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

/**********************************
 * Layout 
 **********************************/
.px-2-5 {
  padding-inline: 0.75rem;
}

.scrollable {
  overflow: auto;
}

.scrollable-y {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.width-auto {
  width: auto;
}

.width-fit {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.width-max {
  width: -webkit-max-content;
  width: max-content;
}

.width-min {
  width: -webkit-min-content;
  width: min-content;
}

.width-100 {
  width: 100%;
}

.width-100-important {
  width: 100% !important;
}

.width-100-vh {
  width: 100vh;
}

.width-75 {
  width: 75%;
}

.width-75-vh {
  width: 75vh;
}

.width-60 {
  width: 60%;
}

.width-60-vh {
  width: 60vh;
}

.width-50 {
  width: 50%;
}

.width-50-vh {
  width: 50vh;
}

.height-auto {
  height: auto;
}

.height-100 {
  height: 100%;
}

.height-100vh {
  height: 100vh;
}

.height-75 {
  height: 75%;
}

.height-75vh {
  height: 75vh;
}

.height-60 {
  height: 60%;
}

.height-60vh {
  height: 60vh;
}

.height-50 {
  height: 50%;
}

.height-50vh {
  height: 50vh;
}

.flex-col-start {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.flex-col-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.flex-col-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flex-col-evenly {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.flex-col-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.flex-row-evenly {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.flex-row-evenly-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-content: space-between;
}

.flex-row-end {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flex-gap-0 {
  gap: 0;
}

.flex-gap-8 {
  gap: 8px;
}

.flex-gap-12 {
  gap: 12px;
}

.flex-gap-16 {
  gap: 16px;
}

.flex-gap-20 {
  gap: 20px;
}

.flex-gap-24 {
  gap: 24px;
}

.grid-3col {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  align-items: center;
  grid-gap: 20px;
  gap: 20px;
  margin: 20px;
}

.grid-flex-switchable {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  align-items: center;
  grid-gap: 16px;
  gap: 16px;
}
@media (min-width: 481px) {
  .grid-flex-switchable {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-content: space-evenly;
    gap: 16px;
  }
}

.responsive-100-auto {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-100-auto {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
}

.responsive-100-50 {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-100-50 {
    width: 50%;
  }
}

.responsive-100-70 {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-100-70 {
    width: 70%;
  }
}

.responsive-80-50 {
  width: 80%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-80-50 {
    width: 50%;
  }
}

.responsive-90-80 {
  width: 90%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-90-80 {
    width: 80%;
  }
}

.responsive-80-50 {
  width: 80%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-80-50 {
    width: 50%;
  }
}

.responsive-40-30 {
  width: 40%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .responsive-40-30 {
    width: 30%;
  }
}

/**********************************
 * Background 
 **********************************/
.bg-color-vat {
  background: #495afc;
}

.bg-color-white {
  background: white;
}

.bg-color-lighter-gray {
  background: #c1c7cd;
}

.bg-color-light-gray {
  background: #93969a;
}

.bg-color-gray {
  background: #67686a;
}

.bg-color-gray-fa {
  background: #fafafa;
}

/********************************** 
 * Basic components & variations
 **********************************/
.checkbox-big {
  transform: scale(1.3);
}

.common-toast {
  position: fixed;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

ul.warning-header {
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
ul.warning-header li::marker {
  font-size: 0.5rem;
}

/**********************************
 * Components
 **********************************/
.sticky-box {
  position: -webkit-sticky;
  position: sticky;
  top: 50px;
  z-index: 100;
  background: #ffffff;
}

.inline-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}
.inline-popup .inline-popup-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(768px, 100vw);
  margin: 0 auto;
  padding: 10px;
  padding-bottom: 56px;
  background: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
@media (max-width: 1440px) and (min-width: 481px) {
  .inline-popup .inline-popup-layout {
    /* transform: translateX(calc((100vw - \$app-width) / 2)); */
  }
}

.round-border-box {
  border-radius: 12px;
  border: 3px solid;
  border-color: #495afc;
  background: white;
}

.round-solid-box {
  border-radius: 10px !important;
  border: none !important;
  padding: 20px 25px;
  width: 100%;
  background-color: #6b63ff;
  color: white;
}
.round-solid-box.theme-bg {
  background-color: #6b63ff;
  color: white;
}
.round-solid-box.theme-bg:disabled {
  background-color: rgba(107, 99, 255, 0.7725490196) !important;
  color: white;
}
.round-solid-box.vat-theme {
  background-color: #495afc;
  color: white;
}
.round-solid-box.vat-theme:disabled {
  background-color: rgba(73, 90, 252, 0.8) !important;
  color: white;
}
.round-solid-box.yellow-theme {
  background-color: #ffc145;
  color: black;
}
.round-solid-box.yellow-theme:disabled {
  background-color: rgba(255, 193, 69, 0.8) !important;
  color: black;
}
.round-solid-box.orange-theme {
  background-color: #d98c00;
  color: white;
}
.round-solid-box.orange-theme:disabled {
  background-color: rgba(217, 140, 0, 0.8) !important;
  color: black;
}
.round-solid-box.light-orange-theme {
  background-color: #f2a61c;
  color: white;
}
.round-solid-box.light-orange-theme:disabled {
  background-color: rgba(242, 166, 28, 0.8) !important;
  color: black;
}

.gray-header-box {
  height: 150px;
  background-color: #f4f5ff;
  margin: 0 -20px;
  padding: 20px;
}

.gray-header-box-small {
  background-color: #f4f5ff;
  margin: 0 -20px;
  padding: 20px;
}

/********************************** 
 * Effects
 **********************************/
.carousel-text-underline {
  text-decoration-color: rgba(253, 237, 79, 0.5);
  text-decoration-thickness: 5px;
  text-decoration-style: solid;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

/********************************** 
 * Image 
 **********************************/
.img-responsive {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive {
    width: 50%;
  }
}

.img-responsive-100-80 {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive-100-80 {
    width: 80%;
  }
}

.img-responsive-100-60 {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive-100-60 {
    width: 60%;
  }
}

.img-responsive-100-50 {
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive-100-50 {
    width: 50%;
  }
}

.img-responsive-80-50 {
  width: 80%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive-80-50 {
    width: 50%;
  }
}

.img-responsive-90 {
  width: 90%;
  margin: 0 auto;
}

.img-responsive-90-75 {
  width: 90%;
  margin: 0 auto;
}
@media (min-width: 481px) {
  .img-responsive-90-75 {
    width: 75%;
  }
}

.img-keep-aspect-ratio {
  width: 100%;
  max-width: 400px;
  height: auto;
  max-height: 200px;
  object-fit: contain;
}

/* SVG styles */
.ic-analyzed {
  filter: invert(8%) sepia(100%) saturate(6481%) hue-rotate(300deg) brightness(102%) contrast(143%);
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB,gBAAA;AACA;EACE,sBAAA;AADF;;AAGA;EACE,oCAAA;EACA,mCAAA;EACA,yBAAA;AAAF;;AAEA,0CAAA;AACA;EACE,aAAA;AACF;;AAEA;;mCAAA;AAGA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qPAAA;AACF;AAOA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,wPAAA;AALF;AAaA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,8PAAA;AAXF;AAmBA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,2PAAA;AAjBF;AAyBA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qPAAA;AAvBF;AA+BA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,wPAAA;AA7BF;AAqCA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uEAAA;EACA,2WAAA;EAQA,kBAAA;AA1CF;AA4CA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6EAAA;EACA,mYAAA;EAQA,kBAAA;AAjDF;AAmDA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wEAAA;EACA,+WAAA;EAQA,kBAAA;AAxDF;AA0DA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0EAAA;EACA,uXAAA;EAQA,kBAAA;AA/DF;AAiEA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yEAAA;EACA,mXAAA;EAQA,kBAAA;AAtEF;AAwEA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2EAAA;EACA,2XAAA;EAQA,kBAAA;AA7EF;AA+EA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uEAAA;EACA,2WAAA;EAQA,kBAAA;AApFF;AAsFA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4EAAA;EACA,+XAAA;EAQA,kBAAA;AA3FF;AA6FA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wEAAA;EACA,+WAAA;EAQA,kBAAA;AAlGF;AAqGA;EACE,4BAAA;AAnGF;;AAqGA;EACE,4BAAA;AAlGF;;AAoGA;EACE,4BAAA;AAjGF;;AAmGA;EACE,eAAA;AAhGF;;AAkGA;EACE,eAAA;AA/FF;;AAiGA;EACE,eAAA;AA9FF;;AAgGA;EACE,eAAA;AA7FF;;AAgGA;EACE,gBAAA;AA7FF;;AA+FA;EACE,gBAAA;AA5FF;;AA8FA;EACE,gBAAA;AA3FF;;AA6FA;EACE,+CAAA;AA1FF;;AA6FA,SAAA;AACA;EACE,cChPY;ADsJd;;AA4FA;EACE,cC1OO;ADiJT;;AA2FA;EACE,cCzOW;ADiJb;;AA0FA;EACE,cC7OW;ADsJb;;AAyFA;EACE,UAAA;AAtFF;;AAwFA;EACE,cCrQe;ADgLjB;;AAuFA;EACE,cClRa;AD8Lf;;AAsFA;EACE,cCpRmB;ADiMrB;;AAqFA;EACE,cC9PK;AD4KP;;AAoFA;EACE,cChRY;AD+Ld;;AAmFA;EACE,cAAA;AAhFF;;AAkFA;EACE,YAAA;AA/EF;;AAkFA;EACE,cCvSoB;ADwNtB;;AAkFA;EACE,cAAA;AA/EF;;AAiFA;EACE,cC5Sa;AD8Nf;;AAgFA;EACE,cAAA;AA7EF;;AA+EA;EACE,cC1RO;AD8MT;;AA8EA;EACE,cCjTgB;ADsOlB;;AA6EA;EACE,cCpTgB;AD0OlB;;AA4EA;EACE,cC1TmB;ADiPrB;;AA2EA;EACE,cC7SK;ADqOP;;AA0EA;EACE,cCrSW;AD8Nb;;AAyEA;EACE,cClTW;AD4Ob;;AAwEA;EACE,cCpTa;AD+Of;;AAuEA;EACE,cC5Sc;ADwOhB;;AAsEA;EACE,cAAA;AAnEF;;AAqEA;EACE,cCjUW;AD+Pb;;AAoEA;EACE,cC1UU;ADyQZ;;AAmEA;EACE,cC5Ue;AD4QjB;;AAmEA;EACE,qBAAA;AAhEF;;AAkEA;EACE,0BAAA;AA/DF;;AAiEA;EACE,kBAAA;EACA,kBAAA;AA9DF;AA+DE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;AA7DJ;;AAgEA;EACE,kBAAA;EACA,kBAAA;AA7DF;AA8DE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;AA5DJ;;AAgEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA7DF;;AA+DA;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;AA5DF;;AA+DA;EACE,iBAAA;AA5DF;;AA8DA;EACE,iBAAA;AA3DF;;AA6DA;EACE,iBAAA;AA1DF;;AA4DA;EACE,iBAAA;AAzDF;;AA2DA;EACE,iBAAA;AAxDF;;AA0DA;EACE,iBAAA;AAvDF;;AA0DA;EACE,gBAAA;AAvDF;;AAyDA;EACE,kBAAA;AAtDF;;AAwDA;EACE,iBAAA;AArDF;;AAwDA;;mCAAA;AAGA;EACE,uBAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAuDA;EACE,gBAAA;EACA,iCAAA;AApDF;;AAuDA;EACE,WAAA;AApDF;;AAsDA;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AAnDF;;AAqDA;EACE,0BAAA;EAAA,kBAAA;AAlDF;;AAoDA;EACE,0BAAA;EAAA,kBAAA;AAjDF;;AAmDA;EACE,WAAA;AAhDF;;AAkDA;EACE,sBAAA;AA/CF;;AAiDA;EACE,YAAA;AA9CF;;AAgDA;EACE,UAAA;AA7CF;;AA+CA;EACE,WAAA;AA5CF;;AA8CA;EACE,UAAA;AA3CF;;AA6CA;EACE,WAAA;AA1CF;;AA4CA;EACE,UAAA;AAzCF;;AA2CA;EACE,WAAA;AAxCF;;AA2CA;EACE,YAAA;AAxCF;;AA0CA;EACE,YAAA;AAvCF;;AAyCA;EACE,aAAA;AAtCF;;AAwCA;EACE,WAAA;AArCF;;AAuCA;EACE,YAAA;AApCF;;AAsCA;EACE,WAAA;AAnCF;;AAqCA;EACE,YAAA;AAlCF;;AAoCA;EACE,WAAA;AAjCF;;AAmCA;EACE,YAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AAhCF;;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA/BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AA9BF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;AA7BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AA5BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AA3BF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA1BF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAzBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAxBF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,4BAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAtBF;;AAwBA;EACE,MAAA;AArBF;;AAuBA;EACE,QAAA;AApBF;;AAsBA;EACE,SAAA;AAnBF;;AAqBA;EACE,SAAA;AAlBF;;AAoBA;EACE,SAAA;AAjBF;;AAmBA;EACE,SAAA;AAhBF;;AAkBA;EACE,aAAA;EACA,kCAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EAAA,SAAA;EACA,YAAA;AAfF;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EAAA,SAAA;AAdF;AElkBI;EF2kBJ;IAQI,aAAA;IACA,mBAAA;IACA,6BAAA;IACA,eAAA;IACA,2BAAA;IACA,SAAA;EAbF;AACF;;AAgBA;EACE,WAAA;EACA,cAAA;AAbF;AEjlBI;EF4lBJ;IAKI,0BAAA;IAAA,uBAAA;IAAA,kBAAA;EAZF;AACF;;AAcA;EACE,WAAA;EACA,cAAA;AAXF;AE3lBI;EFomBJ;IAKI,UAAA;EAVF;AACF;;AAYA;EACE,WAAA;EACA,cAAA;AATF;AErmBI;EF4mBJ;IAKI,UAAA;EARF;AACF;;AAUA;EACE,UAAA;EACA,cAAA;AAPF;AE/mBI;EFonBJ;IAKI,UAAA;EANF;AACF;;AAQA;EACE,UAAA;EACA,cAAA;AALF;AEznBI;EF4nBJ;IAKI,UAAA;EAJF;AACF;;AAMA;EACE,UAAA;EACA,cAAA;AAHF;AEnoBI;EFooBJ;IAKI,UAAA;EAFF;AACF;;AAIA;EACE,UAAA;EACA,cAAA;AADF;AE7oBI;EF4oBJ;IAKI,UAAA;EAAF;AACF;;AAGA;;mCAAA;AAGA;EACE,mBCvpBgB;ADupBlB;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,mBC7oBkB;AD+oBpB;;AAAA;EACE,mBClpBW;ADqpBb;;AADA;EACE,mBCtpBK;AD0pBP;;AAFA;EACE,mBAAA;AAKF;;AAFA;;mCAAA;AAGA;EACE,qBAAA;AAKF;;AAFA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AAKF;;AAFA;EACE,yDAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;;AAFA;;mCAAA;AAGA;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,mBC3qBM;ADgrBR;;AAFA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AAKF;AAHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBChtBQ;EDitBR,cAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;AAKJ;AE3uBI;EF4tBF;IAaI,2DAAA;EAMJ;AACF;;AAFA;EACE,mBAAA;EACA,iBAAA;EACA,qBC1uBgB;ED2uBhB,iBAAA;AAKF;;AAFA;EACE,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBCzvBoB;ED0vBpB,YAAA;AAKF;AAHE;EACE,yBC7vBkB;ED8vBlB,YAAA;AAKJ;AAJI;EACE,6DAAA;EACA,YAAA;AAMN;AAHE;EACE,yBC/vBc;EDgwBd,YAAA;AAKJ;AAJI;EACE,mDAAA;EACA,YAAA;AAMN;AAHE;EACE,yBCnwBiB;EDowBjB,YAAA;AAKJ;AAJI;EACE,oDAAA;EACA,YAAA;AAMN;AAHE;EACE,yBCnxBW;EDoxBX,YAAA;AAKJ;AAJI;EACE,mDAAA;EACA,YAAA;AAMN;AAHE;EACE,yBC1xBiB;ED2xBjB,YAAA;AAKJ;AAJI;EACE,oDAAA;EACA,YAAA;AAMN;;AADA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AAIF;;AADA;EACE,yBAAA;EACA,eAAA;EACA,aAAA;AAIF;;AADA;;mCAAA;AAGA;EACE,8CAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;UAAA,8BAAA;AAIF;;AADA;;mCAAA;AAGA;EACE,WAAA;EACA,cAAA;AAIF;AEl0BI;EF4zBJ;IAII,UAAA;EAMF;AACF;;AAJA;EACE,WAAA;EACA,cAAA;AAOF;AE50BI;EFm0BJ;IAII,UAAA;EASF;AACF;;AAPA;EACE,WAAA;EACA,cAAA;AAUF;AEt1BI;EF00BJ;IAII,UAAA;EAYF;AACF;;AAVA;EACE,WAAA;EACA,cAAA;AAaF;AEh2BI;EFi1BJ;IAII,UAAA;EAeF;AACF;;AAbA;EACE,UAAA;EACA,cAAA;AAgBF;AE12BI;EFw1BJ;IAII,UAAA;EAkBF;AACF;;AAhBA;EACE,UAAA;EACA,cAAA;AAmBF;;AAjBA;EACE,UAAA;EACA,cAAA;AAoBF;AEz3BI;EFm2BJ;IAII,UAAA;EAsBF;AACF;;AAnBA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAsBF;;AAnBA,eAAA;AACA;EACE,iGAAA;AAsBF","sourcesContent":["@import \"styles/variables\";\n@import \"styles/mixins\";\n\n/* Root styles */\n* {\n  box-sizing: border-box;\n}\n:root {\n  --bs-body-font-size: 16px !important;\n  --bs-body-color: #121619 !important;\n  color: #121619 !important;\n}\n/* React: runtime error 검은색 팝업이 뜨는 문제 수정 */\niframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n/********************************** \n * Font \n **********************************/\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 100;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 300;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Noto Sans KR\";\n  font-style: normal;\n  font-weight: 900;\n  src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff2)\n      format(\"woff2\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff)\n      format(\"woff\"),\n    url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.otf)\n      format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 100;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Thin.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 200;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraLight.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 300;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Light.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 400;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Regular.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 500;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Medium.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 600;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-SemiBold.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 700;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Bold.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 800;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-ExtraBold.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n@font-face {\n  font-family: \"SUIT\";\n  font-weight: 900;\n  font-style: normal;\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.eot\");\n  src: url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.jsdelivr.net/gh/webfontworld/sunn/SUIT-Heavy.ttf\")\n      format(\"truetype\");\n  font-display: swap;\n}\n\n.fs-5-5 {\n  font-size: 1.1rem !important;\n}\n.fs-6-5 {\n  font-size: 0.9rem !important;\n}\n.fs-7 {\n  font-size: 0.8rem !important;\n}\n.text-size-16 {\n  font-size: 16px;\n}\n.text-size-18 {\n  font-size: 18px;\n}\n.text-size-20 {\n  font-size: 20px;\n}\n.text-size-24 {\n  font-size: 24px;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n.fw-300 {\n  font-weight: 300;\n}\n.fw-100 {\n  font-weight: 100;\n}\n.font-suit {\n  font-family: \"SUIT\", \"Noto Sans KR\", sans-serif;\n}\n\n/* Text */\n.text-light-black {\n  color: $light-black;\n}\n.text-yellow {\n  color: $yellow;\n}\n.text-gray-1 {\n  color: $app-gray-1;\n}\n.text-gray-2 {\n  color: $other-gray;\n}\n.text-red {\n  color: red;\n}\n.text-depp-red {\n  color: $deep-red-color;\n}\n.text-orange {\n  color: $orange-color;\n}\n.text-light-orange {\n  color: $light-orange-color;\n}\n.text-blue {\n  color: $blue;\n}\n.text-green {\n  color: $green-color;\n}\n.text-starbucks-green {\n  color: #034f30;\n}\n.text-white {\n  color: white;\n}\n\n.text-primary {\n  color: $theme-color-primary;\n}\n\n.text-yellow-new {\n  color: #ffe515;\n}\n.text-orange {\n  color: $orange-color;\n}\n.text-gray {\n  color: #999999;\n}\n.text-purple {\n  color: $purple;\n}\n.text-vat {\n  color: $vat-theme-color;\n}\n.text-vat-theme {\n  color: $vat-theme-color;\n}\n.text-light-orange {\n  color: $light-orange-color;\n}\n.text-light-gray {\n  color: $gray;\n}\n.text-other-gray {\n  color: $other-gray;\n}\n.text-lighter-gray {\n  color: $light-gray;\n}\n.text-more-lighter-gray {\n  color: $lighter-gray;\n}\n.text-dark-gray {\n  color: $app-dark-gray;\n}\n.text-deep-dark-gray {\n  color: #3b3b3b;\n}\n.text-semi-black {\n  color: $semi-black;\n}\n.text-red {\n  color: $red-color;\n}\n.text-deep-red {\n  color: $deep-red-color;\n}\n\n.text-pre-line {\n  white-space: pre-line;\n}\n.text-underline {\n  text-decoration: underline;\n}\n.text-thick-underline {\n  position: relative;\n  isolation: isolate;\n  &::after {\n    position: absolute;\n    width: 90%;\n    height: 10px;\n    bottom: 0px;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    background-color: #ffe800;\n    z-index: -1;\n    content: \"\";\n  }\n}\n.text-thick-underline-full-width {\n  position: relative;\n  isolation: isolate;\n  &::after {\n    position: absolute;\n    width: 100%;\n    height: 10px;\n    bottom: 0px;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    background-color: #ffe800;\n    z-index: -1;\n    content: \"\";\n  }\n}\n\n.text-overflow-ellipsis {\n  overflow: hidden; // 박스에서 넘쳐난 텍스트 숨기기\n  text-overflow: ellipsis; // ... 말줄임 효과\n  white-space: nowrap; // 줄바꿈이 없어짐\n  word-break: break-all; // 어절이 유지되지 않고 끊어져서 줄바꿈 됨\n}\n.text-overflow-keep {\n  overflow: visible; // 박스에서 넘쳐난 텍스트 숨기기\n  white-space: nowrap; // 줄바꿈이 없어짐\n  word-break: keep-all; // 어절이 유지되지 않고 끊어져서 줄바꿈 됨\n}\n\n.line-height-100 {\n  line-height: 100%;\n}\n.line-height-120 {\n  line-height: 120%;\n}\n.line-height-140 {\n  line-height: 140%;\n}\n.line-height-160 {\n  line-height: 160%;\n}\n.line-height-180 {\n  line-height: 180%;\n}\n.line-height-200 {\n  line-height: 200%;\n}\n\n.text-align-left {\n  text-align: left;\n}\n.text-align-center {\n  text-align: center;\n}\n.text-align-right {\n  text-align: right;\n}\n\n/**********************************\n * Layout \n **********************************/\n.px-2-5 {\n  padding-inline: 0.75rem;\n}\n\n.scrollable {\n  overflow: auto;\n}\n.scrollable-y {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.width-auto {\n  width: auto;\n}\n.width-fit {\n  width: fit-content;\n}\n.width-max {\n  width: max-content;\n}\n.width-min {\n  width: min-content;\n}\n.width-100 {\n  width: 100%;\n}\n.width-100-important {\n  width: 100% !important;\n}\n.width-100-vh {\n  width: 100vh;\n}\n.width-75 {\n  width: 75%;\n}\n.width-75-vh {\n  width: 75vh;\n}\n.width-60 {\n  width: 60%;\n}\n.width-60-vh {\n  width: 60vh;\n}\n.width-50 {\n  width: 50%;\n}\n.width-50-vh {\n  width: 50vh;\n}\n\n.height-auto {\n  height: auto;\n}\n.height-100 {\n  height: 100%;\n}\n.height-100vh {\n  height: 100vh;\n}\n.height-75 {\n  height: 75%;\n}\n.height-75vh {\n  height: 75vh;\n}\n.height-60 {\n  height: 60%;\n}\n.height-60vh {\n  height: 60vh;\n}\n.height-50 {\n  height: 50%;\n}\n.height-50vh {\n  height: 50vh;\n}\n\n.flex-col-start {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.flex-col-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex-col-between {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.flex-col-evenly {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n.flex-col-end {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n.flex-row-start {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex-row-center {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.flex-row-between {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex-row-evenly {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n.flex-row-evenly-wrap {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n  align-content: space-between;\n}\n.flex-row-end {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex-gap-0 {\n  gap: 0;\n}\n.flex-gap-8 {\n  gap: 8px;\n}\n.flex-gap-12 {\n  gap: 12px;\n}\n.flex-gap-16 {\n  gap: 16px;\n}\n.flex-gap-20 {\n  gap: 20px;\n}\n.flex-gap-24 {\n  gap: 24px;\n}\n.grid-3col {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  justify-items: center;\n  align-items: center;\n  gap: 20px;\n  margin: 20px;\n}\n.grid-flex-switchable {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  justify-items: center;\n  align-items: center;\n  gap: 16px;\n\n  @include TabletAndPC() {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    align-content: space-evenly;\n    gap: 16px;\n  }\n}\n\n.responsive-100-auto {\n  width: 100%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: fit-content;\n  }\n}\n.responsive-100-50 {\n  width: 100%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.responsive-100-70 {\n  width: 100%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 70%;\n  }\n}\n.responsive-80-50 {\n  width: 80%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.responsive-90-80 {\n  width: 90%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 80%;\n  }\n}\n.responsive-80-50 {\n  width: 80%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.responsive-40-30 {\n  width: 40%;\n  margin: 0 auto;\n\n  @include TabletAndPC() {\n    width: 30%;\n  }\n}\n\n/**********************************\n * Background \n **********************************/\n.bg-color-vat {\n  background: $vat-theme-color;\n}\n.bg-color-white {\n  background: white;\n}\n.bg-color-lighter-gray {\n  background: $more-lighter-gray;\n}\n.bg-color-light-gray {\n  background: $light-gray;\n}\n.bg-color-gray {\n  background: $gray;\n}\n.bg-color-gray-fa {\n  background: #fafafa;\n}\n\n/********************************** \n * Basic components & variations\n **********************************/\n.checkbox-big {\n  transform: scale(1.3);\n}\n\n.common-toast {\n  position: fixed;\n  top: 80%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n}\n\nul.warning-header {\n  list-style-image: url(\"../assets/ic_exclamation.png\");\n  li::marker {\n    font-size: 0.5rem;\n  }\n}\n\n/**********************************\n * Components\n **********************************/\n.sticky-box {\n  position: sticky;\n  top: 50px;\n  z-index: 100;\n  background: $white;\n}\n\n.inline-popup {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n\n  .inline-popup-layout {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: $app-width;\n    margin: 0 auto;\n    padding: 10px;\n    padding-bottom: 56px;\n    background: white;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n\n    @include Tablet() {\n      /* transform: translateX(calc((100vw - $app-width) / 2)); */\n    }\n  }\n}\n\n.round-border-box {\n  border-radius: 12px;\n  border: 3px solid;\n  border-color: $vat-theme-color;\n  background: white;\n}\n\n.round-solid-box {\n  border-radius: 10px !important;\n  border: none !important;\n  padding: 20px 25px;\n  width: 100%;\n  background-color: $theme-color-primary;\n  color: white;\n\n  &.theme-bg {\n    background-color: $theme-color-primary;\n    color: white;\n    &:disabled {\n      background-color: $theme-color-primary-light !important;\n      color: white;\n    }\n  }\n  &.vat-theme {\n    background-color: $vat-theme-color;\n    color: white;\n    &:disabled {\n      background-color: rgba($vat-theme-color, 0.8) !important;\n      color: white;\n    }\n  }\n  &.yellow-theme {\n    background-color: $yellow-theme-color;\n    color: black;\n    &:disabled {\n      background-color: rgba($yellow-theme-color, 0.8) !important;\n      color: black;\n    }\n  }\n  &.orange-theme {\n    background-color: $orange-color;\n    color: white;\n    &:disabled {\n      background-color: rgba($orange-color, 0.8) !important;\n      color: black;\n    }\n  }\n  &.light-orange-theme {\n    background-color: $light-orange-color;\n    color: white;\n    &:disabled {\n      background-color: rgba($light-orange-color, 0.8) !important;\n      color: black;\n    }\n  }\n}\n\n.gray-header-box {\n  height: 150px;\n  background-color: #f4f5ff;\n  margin: 0 -20px;\n  padding: 20px;\n}\n\n.gray-header-box-small {\n  background-color: #f4f5ff;\n  margin: 0 -20px;\n  padding: 20px;\n}\n\n/********************************** \n * Effects\n **********************************/\n.carousel-text-underline {\n  text-decoration-color: rgba(253, 237, 79, 0.5);\n  text-decoration-thickness: 5px;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n}\n\n/********************************** \n * Image \n **********************************/\n.img-responsive {\n  width: 100%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.img-responsive-100-80 {\n  width: 100%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 80%;\n  }\n}\n.img-responsive-100-60 {\n  width: 100%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 60%;\n  }\n}\n.img-responsive-100-50 {\n  width: 100%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.img-responsive-80-50 {\n  width: 80%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 50%;\n  }\n}\n.img-responsive-90 {\n  width: 90%;\n  margin: 0 auto;\n}\n.img-responsive-90-75 {\n  width: 90%;\n  margin: 0 auto;\n  @include TabletAndPC() {\n    width: 75%;\n  }\n}\n\n.img-keep-aspect-ratio {\n  width: 100%;\n  max-width: 400px;\n  height: auto;\n  max-height: 200px;\n  object-fit: contain;\n}\n\n/* SVG styles */\n.ic-analyzed {\n  filter: invert(8%) sepia(100%) saturate(6481%) hue-rotate(300deg)\n    brightness(102%) contrast(143%);\n}\n","$small-screen: 100vw;\n$medium-screen: 80vw;\n$large-screen: 60vw;\n$xlarge-screen: 40vw;\n$label1-color: #383850;\n$label2-color: #999999;\n$label3-color: #3d2f31;\n$theme-color-primary: #6b63ff;\n$theme-color-primary-light: #6b63ffc5;\n$orange-color: #d98c00;\n$light-orange-color: #f2a61c;\n$yellow-color-light: #ffc145d0;\n$yellow-color-new: #ffc519;\n$vat-theme-color: #495afc;\n$vat-theme-color-dark: #4251e3;\n$vat-theme-color-dark-more: #3b49cc;\n$blue-red-color: #d98c00;\n$yellow-theme-color: #ffc145;\n$red-color: #f80707;\n$deep-red-color: #cb2128;\n$green-color: #4aba64;\n$light-green: #00b33c;\n$app-width: min(768px, 100vw);\n$app-width-extra: min(768px, 101vw);\n$semi-black: #121619;\n$light-black: #373b3e;\n$gray: #67686a;\n$light-gray: #93969a;\n$lighter-gray: #c4c4c4;\n$more-lighter-gray: #c1c7cd;\n$light-white: #fafafa;\n$lighter-white: #f2f4f8;\n$lighter-white2: #f4f5ff;\n$purple: #6c63ff;\n$yellow: #ffe800;\n$blue: #0d6efd;\n$common-border-color: #dde1e6;\n$other-gray: #878d96;\n$app-gray-1: #697077;\n$app-dark-gray: #697077;\n$white: #ffffff;\n$toss-navy: #435a78;\n$toss-ivory: #f9fafb;\n$toss-black: #333d4b;\n$toss-gray: #f3f4f6;\n$toss-blue: #4493fc;\n","@mixin Mobile() {\n    @media (max-width: 480px) {\n        @content;\n    }\n}\n@mixin Tablet() {\n    @media (max-width: 1440px) and (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletAndPC() {\n    @media (min-width: 481px) {\n        @content;\n    }\n}\n@mixin TabletVertical() {\n    @media (max-width: 768px) and (orientation: portrait) {\n        @content;\n    }\n}\n@mixin TabletHorizontal() {\n    @media (max-width: 768px) and (orientation: landscape) {\n        @content;\n    }\n}\n@mixin PC() {\n    @media (min-width: 769px) {\n        @content;\n    }\n}\n@mixin LowHeight() {\n    @media (max-height: 700px) {\n        @content;\n    }\n}\n@mixin LowHeightVertical() {\n    @media (max-height: 700px) and (min-width: 769px) {\n        @content;\n    }\n}\n@mixin HighHeight() {\n    @media (min-height: 701px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
